__turbopack_context__.v({
  "button-container": "QrNYDG_button-container",
  "cancel-button": "QrNYDG_cancel-button",
  "edit-button": "QrNYDG_edit-button",
  "save-button": "QrNYDG_save-button",
});
